import React from 'react'
import ReactDOM from 'react-dom'
import {browserHistory} from 'react-router'
// import * as firebase from 'firebase'
import JRouter from './JRouter'

// const config = {
//   apiKey: "AIzaSyAqF6Qb5txh3zF0YkIUmAp3Jn7s3mY_65o",
//   authDomain: "jreact-89e11.firebaseapp.com",
//   databaseURL: "https://jreact-89e11.firebaseio.com",
//   projectId: "jreact-89e11",
//   storageBucket: "jreact-89e11.appspot.com",
//   messagingSenderId: "106735469022"
// }
//
// firebase.initializeApp(config);

// ReactDOM.render(
//   <App {...config} />,
//   document.getElementById('root')
// );

ReactDOM.render(
  <JRouter history={browserHistory} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js